import { all, call, put, takeLatest } from "redux-saga/effects";
import { GetVoiceMailUrlErrorAction, GetVoiceMailUrlRequestAction, GetVoiceMailUrlSuccessAction, PostVoiceMailUrlErrorAction, PostVoiceMailUrlSuccessAction, getAudioFileErrorAction, getAudioFileSuccessAction, getVoiceMailBoxesErrorAction, getVoiceMailBoxesSuccessAction, getVoiceMailsErrorAction, getVoiceMailsRequestAction, getVoiceMailsSuccessAction, moveToTrashErrorAction, moveToTrashSuccessAction, setHeardByVoicemailIdErrorAction, setHeardByVoicemailIdSuccessAction } from "../../actions/voiceMailActions";
import { Types } from "../../types";
import { GetVoicemailBoxesResponse, voiceMailResponse } from "../../types/voiceMail/apiRequestTypes";
import { getAudioFile, getInboxVoicemailsByFilter, getVoiceMailBoxes, insertVoicemailUrlRequest, moveToTrash, setHeardByVoicemailId, getVoicemailUrlRequest } from "../apiRequests/voiceMailRequest";
import { VoiceMail } from "../../interfaces/voiceMail";



function* getInboxVoicemailsByFilterHandler(action: any) {
    try {
        const response: { data: voiceMailResponse } = yield call(getInboxVoicemailsByFilter, action.payload)
        let voiceMail = new VoiceMail()
        voiceMail.mapper(response.data)
        yield put(
            getVoiceMailsSuccessAction({
                params: voiceMail
            })
        )

    } catch (error: any) {
        yield put(
            getVoiceMailsErrorAction({
                error: error.message
            })
        )

    }
}
//************************************************************************************************************************* */
function* getAudioFileHandler(action: any) {
    try {
        const response: { data: string } = yield call(getAudioFile, action.payload)
        yield put(
            getAudioFileSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getAudioFileErrorAction({
                error: error.message
            })
        )

    }
}
//************************************************************************************************************************** */
function* moveToTrashHandler(action: any) {

    try {
        const response: { data: voiceMailResponse } = yield call(moveToTrash, action.payload)
        yield put(
            moveToTrashSuccessAction()
        )

    } catch (error: any) {
        yield put(
            moveToTrashErrorAction({
                error: error.message
            })
        )

    }
}
//************************************************************************************************************************** */
function* setHeardByVoicemailIdHandler(action: any) {
    try {
        const response: { data: voiceMailResponse } = yield call(setHeardByVoicemailId, action.payload)
        yield put(
            setHeardByVoicemailIdSuccessAction()
        )

    } catch (error: any) {
        yield put(
            setHeardByVoicemailIdErrorAction({
                error: error.message
            })
        )

    }
}
//****************************************************************************************************************************** */
function* getVoicemailBoxesHandler(action: any) {
    try {
        const response: { data: GetVoicemailBoxesResponse } = yield call(getVoiceMailBoxes, action.payload)
        yield put(
            getVoiceMailBoxesSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getVoiceMailBoxesErrorAction({
                error: error.message
            })
        )

    }
}
//********************************************************************************************************************************* */


function* handleGetVoiceMailUrlHandler(action: any) {
    try {
        const response: { data: any } = yield call(getVoicemailUrlRequest, action.payload)
        yield put(
            GetVoiceMailUrlSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            GetVoiceMailUrlErrorAction({
                error: error.message
            })
        )

    }
}


function* handlePostVoiceMailUrlHandler(action: any) {
    try {
        const response: { data: any } = yield call(insertVoicemailUrlRequest, action.payload)
        yield put(
            PostVoiceMailUrlSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            PostVoiceMailUrlErrorAction({
                error: error.message
            })
        )

    }
}

function* voiceMailSaga() {
    yield all([takeLatest(Types.GET_VOICE_MAIL_REQUEST, getInboxVoicemailsByFilterHandler)]);
    yield all([takeLatest(Types.MOVE_TO_TRASH_VOICE_EMAIL_REQUEST, moveToTrashHandler)]);
    yield all([takeLatest(Types.SET_HEARD_BY_VOICE_EMAIL_ID_REQUEST, setHeardByVoicemailIdHandler)]);
    yield all([takeLatest(Types.GET_AUDIO_FILE_VOICE_MAIL_REQUEST, getAudioFileHandler)]);
    yield all([takeLatest(Types.GET_VOICE_MAIL_BOX_REQUEST, getVoicemailBoxesHandler)]);

    yield all([takeLatest(Types.GET_LINE_VOICE_MAIL_URL_REQUEST, handleGetVoiceMailUrlHandler)]);
    yield all([takeLatest(Types.POST_LINE_VOICE_MAIL_URL_REQUEST, handlePostVoiceMailUrlHandler)]);


}

export default voiceMailSaga